// import Vue from 'vue'
// import VueRouter from 'vue-router'
// import admin from './admin'
// import user from './user'
// import store from '@/store'
// import axios from '@/libs/axios'

// Vue.use(VueRouter)

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   scrollBehavior() {
//     return { x: 0, y: 0 }
//   },
//   routes: [
//     ...user,
//     ...admin,
//     {
//       path: '/second-page',
//       name: 'second-page',
//       component: () => import('@/views/SecondPage.vue'),
//       meta: {
//         pageTitle: 'Second Page',
//         breadcrumb: [
//           {
//             text: 'Second Page',
//             active: true,
//           },
//         ],
//       },
//     },
//     {
//       path: '/login',
//       name: 'login',
//       component: () => import('@/views/Login.vue'),
//       meta: {
//         layout: 'full',
//       },
//     },
//     {
//       path: '/noauth',
//       name: 'noauth',
//       component: () => import('@/views/error/Error401.vue'),
//       meta: { layout: 'full' }
//     },
//     {
//       path: '/:catchAll(.*)',
//       name: 'catch-all',
//       component: () => import('@/views/error/Error404.vue'),
//       meta: { layout: 'full' }
//     }
//   ],
// })


// let __guardRunId = 0;

// function normalizeTokenStrict(raw) {
//   // normalisasi token: kembalikan null kecuali token valid non-empty string
//   if (!raw) return null;

//   // kalau getter mengembalikan array payload seperti [ {type:'token', value:'...'} ]
//   if (Array.isArray(raw)) {
//     const t = raw.find(x => x && x.type === 'token' && x.value);
//     if (!t || !t.value) return null;
//     const v = String(t.value).trim();
//     return v === '' || v === 'null' || v === 'undefined' ? null : v;
//   }

//   // object { value: '...' } atau { token: '...' }
//   if (typeof raw === 'object') {
//     const maybe = raw.value || raw.token || null;
//     if (!maybe) return null;
//     const v = String(maybe).trim();
//     return v === '' || v === 'null' || v === 'undefined' ? null : v;
//   }

//   // string
//   if (typeof raw === 'string') {
//     const s = raw.trim();
//     return (s === '' || s === 'null' || s === 'undefined') ? null : s;
//   }

//   return null;
// }

// router.beforeEach(async (to, from, next) => {
//   const runId = ++__guardRunId;
//   try {
//     const rawToken = store.getters['oauth/getToken'];
//     const localToken = (localStorage.getItem('token') || localStorage.getItem('access_token') || null);
//     const token = normalizeTokenStrict(rawToken) || (localToken ? String(localToken).trim() : null);
//     if (to.path === '/login') return next();
//     if (to.path === '/error-404' || to.name === 'catch-all' || to.name === 'error-404-catch') return next();

//     if (to.path === '/') {
//       if (!token) {
//         console.trace(); 
//         return next({ name: 'login' });
//       }
//       store.commit('oauth/setToken', [{ type: 'token', value: token }]);
//       store.dispatch('app/checkShowNPSRate').catch(()=>{});
//       return next();
//     }

//     if (to.meta?.requiresAuth && !token) {
//       return next({ name: 'catch-all' });
//     }

//     if (to.matched.length === 0) {
//       return next({ name: 'catch-all' });
//     }

//     if (!token) {
//       console.trace();
//       return next({ name: 'catch-all' });
//     }

//     if (!token && !to.meta?.requiresAuth) {
//       return next();
//     }

//     if (to.meta && to.meta.page_admin) store.commit('app/SET_IS_ADMIN', true);

//     store.commit('oauth/setToken', [{ type: 'token', value: token }]);
//     store.dispatch('app/checkShowNPSRate').catch(()=>{});

//     if (to.path.includes('admin')) {
//       let thisRole = localStorage.getItem('role');
//       if (thisRole == null) {
//         try {
//           const res = await store.dispatch('oauth/getAuthUser');
//           const role = res?.account?.me?.role || '';
//           if (role.includes('telkom a') || role.includes('telkom b') || role.length === 0) {
//             return router.go(-1);
//           } else {
//             return next();
//           }
//         } catch (err) {
//           return next({ name: 'catch-all' });
//         }
//       } else {
//         if (thisRole.includes('telkom a') || thisRole.includes('telkom b') || thisRole.length === 0) {
//           return router.go(-1);
//         } else {
//           return next();
//         }
//       }
//     }

//     store.commit('app/SET_PAGE_TITLE', '');
//     return next();
//   } catch (err) {
//     console.error('[router.guard] unexpected error', err);
//     return next({ name: 'catch-all' });
//   }
// });


// router.afterEach((to) => {
//   axios.post('/tracker', {
//     action: 'visit',
//     page: to.name,
//     path: to.path
//   })
// })

// export default router

import Vue from 'vue'
import VueRouter from 'vue-router'
import admin from './admin'
import user from './user'
import store from '@/store'
import axios from '@/libs/axios'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    ...user,
    ...admin,
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        pageTitle: 'Second Page',
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: { layout: 'full' },
    },
    {
      path: '/noauth',
      name: 'noauth',
      component: () => import('@/views/error/Error401.vue'),
      meta: { layout: 'full' },
    },
    {
      path: '/:catchAll(.*)',
      name: 'catch-all',
      component: () => import('@/views/error/Error404.vue'),
      meta: { layout: 'full' },
    },
  ],
})

let __guardRunId = 0

function normalizeTokenStrict(raw) {
  if (!raw) return null
  if (Array.isArray(raw)) {
    const t = raw.find(x => x && x.type === 'token' && x.value)
    if (!t || !t.value) return null
    const v = String(t.value).trim()
    return v === '' || v === 'null' || v === 'undefined' ? null : v
  }
  if (typeof raw === 'object') {
    const maybe = raw.value || raw.token || null
    if (!maybe) return null
    const v = String(maybe).trim()
    return v === '' || v === 'null' || v === 'undefined' ? null : v
  }
  if (typeof raw === 'string') {
    const s = raw.trim()
    return s === '' || s === 'null' || s === 'undefined' ? null : s
  }
  return null
}

router.beforeEach(async (to, from, next) => {
  const runId = ++__guardRunId
  try {
    const rawToken = store.getters['oauth/getToken']
    const localToken =
      localStorage.getItem('token') || localStorage.getItem('access_token') || null
    const token =
      normalizeTokenStrict(rawToken) || (localToken ? String(localToken).trim() : null)

    if (to.path === '/login' || to.name === 'catch-all' || to.name === 'error-404-catch') {
      return next()
    }

    if (to.matched.length === 0) {
      return next({ name: 'catch-all' })
    }

    if (to.path === '/') {
      if (!token) {
        return next({ name: 'login' })
      }
      store.commit('oauth/setToken', [{ type: 'token', value: token }])
      store.dispatch('app/checkShowNPSRate').catch(() => {})
      return next()
    }

    if (to.meta?.requiresAuth && !token) {
      return next({ name: 'login' })
    }

    if (!token) {
      return next({ name: 'login' })
    }

    if (to.meta && to.meta.page_admin) store.commit('app/SET_IS_ADMIN', true)

    store.commit('oauth/setToken', [{ type: 'token', value: token }])
    store.dispatch('app/checkShowNPSRate').catch(() => {})

    if (to.path.includes('admin')) {
      let thisRole = localStorage.getItem('role')
      if (thisRole == null) {
        try {
          const res = await store.dispatch('oauth/getAuthUser')
          const role = res?.account?.me?.role || ''
          if (role.includes('telkom a') || role.includes('telkom b') || role.length === 0) {
            return router.go(-1)
          } else {
            return next()
          }
        } catch (err) {
          return next({ name: 'catch-all' })
        }
      } else {
        if (thisRole.includes('telkom a') || thisRole.includes('telkom b') || thisRole.length === 0) {
          return router.go(-1)
        } else {
          return next()
        }
      }
    }

    store.commit('app/SET_PAGE_TITLE', '')
    return next()
  } catch (err) {
    console.error('[router.guard] unexpected error', err)
    return next({ name: 'catch-all' })
  }
})

router.afterEach((to) => {
  axios.post('/tracker', {
    action: 'visit',
    page: to.name,
    path: to.path,
  })
})

export default router
